import React from "react"

export default function About() {
  return <div className='font-sans font-semibold md:w-10/12'>
    <img
          className="h-96 m-auto w-auto md:h-48"
          src={`img/y0679.png`}
          alt="image of About"
    />
    <div className='m-8 p-8'>
      <p className='border-l-4 border-yellow-200 mt-10'>Name:</p>
      <p className='mt-4 ml-4'>Anno Ryoya</p>
      <p className='border-l-4 border-yellow-200 mt-10'>Age:</p>
      <p className='mt-4 ml-4'>23</p>
      <p className='border-l-4 border-yellow-200 mt-10'>Profile:</p>
      <p className='mt-4 ml-4'>Webアプリケーションエンジニアを3年経験。フロントエンド（React）～バックエンド（Express）の設計・開発経験があり、クラウド(Azure)の構築ノウハウを身に着けた。
  また、CICDの開発・リリース時の側面も含めた、Webサービス全体のアーキテクチャ設計・実装経験もあり。</p>
    </div>
  </div>
}
